/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createShoppingCartFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ShoppingCart } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/carts/{cart-id}/{shoppingCartId}/refresh-prices
 */
export interface RefreshPricesRequestBuilder extends BaseRequestBuilder<RefreshPricesRequestBuilder> {
    /**
     * Repricies every line at current product pricing for the cart's price tier and quantities. Forced: it runs regardless of the organization's stale-price setting and of how recently the cart was last refreshed. Line discounts are preserved, and a line whose product can no longer be priced keeps its existing price.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ShoppingCart>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ShoppingCart | undefined>;
    /**
     * Repricies every line at current product pricing for the cart's price tier and quantities. Forced: it runs regardless of the organization's stale-price setting and of how recently the cart was last refreshed. Line discounts are preserved, and a line whose product can no longer be priced keeps its existing price.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RefreshPricesRequestBuilderUriTemplate = "{+baseurl}/api/carts/{cart%2Did}/{shoppingCartId}/refresh-prices";
/**
 * Metadata for all the requests in the request builder.
 */
export const RefreshPricesRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RefreshPricesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createShoppingCartFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
